import { getIn } from 'icepick';

export function getChoicesFilteredByLinkLogic(question, parentSelectedValues) {
  const { choices, linkLogic } = question.questionTypeInfo;
  if (!linkLogic) {
    return choices;
  }
  if (!parentSelectedValues || parentSelectedValues.length === 0) {
    // If no values are selected, the default rule (the one that doesn't have a parent choice) applies
    const defaultRule = linkLogic.linkRules.find(rule => !rule.parentChoice);
    const defaultChoices = defaultRule ? defaultRule.childChoices : [];
    return choices.filter(choice => defaultChoices.includes(choice.text));
  }
  // If any values are selected, any rule whose parent choice is selected applies
  const applicableRules = linkLogic.linkRules.filter(rule => parentSelectedValues.includes(rule.parentChoice));
  if (applicableRules.length === 0) {
    return [];
  }
  return choices.filter(choice => !!applicableRules.find(rule => rule.childChoices.includes(choice.text)));
}

export function filterQuestionChoicesByLinkLogic(question, parentSelectedValues) {
  const choices = getChoicesFilteredByLinkLogic(question, parentSelectedValues);
  if (question.questionTypeInfo.choices === choices) {
    return question;
  }
  return {
    ...question,
    questionTypeInfo: {
      ...question.questionTypeInfo,
      choices
    }
  };
}

export function filterFieldChoicesByLinkLogic(fieldDefinition, parentSelectedValues) {
  const question = filterQuestionChoicesByLinkLogic(fieldDefinition.question, parentSelectedValues);
  return fieldDefinition.question === question ? fieldDefinition : { ...fieldDefinition, question };
}

export function getChildCustomFieldsByParentCustomFieldId(state, customFieldId) {
  return Object.values(state.account.contactCustomFields).filter(
    ccf => ccf.question.questionTypeInfo.linkLogic &&
      (ccf.question.questionTypeInfo.linkLogic.parentQuestionId === customFieldId));
}

export function getSelectedMerchantAccount(state, selectedMerchantAccountId) {
  let selectedMerchantAccount;
  if (selectedMerchantAccountId) {
    const selectedMerchants = state.merchantAccounts
      .filter(account => account.merchantAccountId === selectedMerchantAccountId);
    if (selectedMerchants && selectedMerchants.length > 0) {
      selectedMerchantAccount = selectedMerchants[0];
    }
    return selectedMerchantAccount;
  }
}

export function getAccountSessionCategories(state) {
  return state.account.sessionCategories;
}

export function getSessionCustomFieldDefinitions(account) {
  return account.sessionCustomFields;
}

export function getAccountSpeakerCategories(state) {
  return state.account.speakerCategories || {};
}

export function getAccountCurrencies(state) {
  return getIn(state, ['account', 'accountCurrencies']) || [];
}

export function getAccountDefaultCurrencyId(state) {
  return getIn(state, ['account', 'settings', 'baseCurrencyId']);
}
